import { FlowProvider, type FlowProviderProps } from '../flow-provider.tsx';
import { FlowHeader } from './flow-header.tsx';
import { FlowContent } from './flow-content.tsx';
import styles from './flow.module.css';
import { FlowHeaderBar } from './flow-header-bar.tsx';

export type FlowProps<State> = FlowProviderProps<State>;

export function Flow<State>({ children, ...props }: FlowProps<State>): React.JSX.Element {
  return (
    <FlowProvider {...props}>
      <main className={styles.flow}>{children}</main>
    </FlowProvider>
  );
}

Flow.Header = FlowHeader;
Flow.HeaderBar = FlowHeaderBar;
Flow.Content = FlowContent;
